import { render, staticRenderFns } from "./fklb.vue?vue&type=template&id=a7846c10&scoped=true&"
import script from "./fklb.vue?vue&type=script&lang=js&"
export * from "./fklb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7846c10",
  null
  
)

export default component.exports